import React from 'react';
import Img from 'gatsby-image';

class HomeHero extends React.Component {
  smoothScroll = () => {
    const target = document.querySelector(`#contact`);
    target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  };

  render() {
    return (
      <header
        className="fullscreen-element no-pad centered-text"
        style={{ display: 'flex', alignItems: 'center' }}
        id="main"
      >
        {/* <div className="background-image-holder parallax-background overlay skrollable skrollable-between" /> */}

        <div className="container align-vertical">
          <div className="row">
            <div className="col-md-8 text-left">
              <h1 className="text-white">Uniknij niepewności i kar</h1>
              <p className="lead text-white">Związanych z nieprzestrzeganiem postanowień o ochronie danych osobowych</p>
              <a onClick={this.smoothScroll} className="btn btn-primary btn-filled">
                Zostaw numer telefonu
              </a>
            </div>
          </div>
        </div>
        <Img
          resolutions={this.props.heroImage.resolutions}
          className="background-image-holder"
          position="absolute"
          outerWrapperClassName="background-image-holder"
        />
      </header>
    );
  }
}

export default HomeHero;



// WEBPACK FOOTER //
// ./src/components/HomeHero.js